import * as z from 'zod';
import { ParticipantStatusSchema } from '../enums/ParticipantStatus.schema';

export const EventBoatSchema = z.object({
  id: z.string(),
  eventId: z.string(),
  class: z.string().min(1, 'Class is required'),
  sailNumber: z.string().min(1, 'Sail number is required'),
  eventPricePointId: z.string(),
  checkoutId: z.string(),
  status: ParticipantStatusSchema.default("PENDING"),
  paymentAmountCents: z.number().int().nullish(),
  depositAmountCents: z.number().int().nullish(),
  balanceDueAt: z.coerce.date().nullish(),
  stripePaymentIntentId: z.string().nullish(),
  stripePaymentIntentStatus: z.string().nullish(),
  stripeRefundId: z.string().nullish(),
  depositStripePaymentIntentId: z.string().nullish(),
  depositStripePaymentIntentStatus: z.string().nullish(),
  depositCapturedAt: z.coerce.date().nullish(),
  depositRefundId: z.string().nullish(),
  paymentCapturedAt: z.coerce.date().nullish(),
  paymentReleasedAt: z.coerce.date().nullish(),
  balanceTakenAt: z.coerce.date().nullish(),
  balanceTakenBy: z.string().nullish(),
  sharedPaymentIntentId: z.string().nullish(),
  sharedPaymentIntentStatus: z.string().nullish(),
  sharedAllocatedAmountCents: z.number().int().nullish(),
  sharedAllocatedRefundId: z.string().nullish(),
  sharedDepositPaymentIntentId: z.string().nullish(),
  sharedDepositPaymentIntentStatus: z.string().nullish(),
  sharedDepositAllocatedAmountCents: z.number().int().nullish(),
  sharedDepositAllocatedRefundId: z.string().nullish(),
  submittedAt: z.coerce.date().nullish(),
  approvedAt: z.coerce.date().nullish(),
  approvedBy: z.string().nullish(),
  rejectedAt: z.coerce.date().nullish(),
  rejectedBy: z.string().nullish(),
  rejectionReason: z.string().nullish(),
  cancelledAt: z.coerce.date().nullish(),
  cancelledBy: z.string().nullish(),
  cancellationReason: z.string().nullish(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type EventBoatType = z.infer<typeof EventBoatSchema>;
